import { render } from "./simpleCertificate.vue?vue&type=template&id=72d53b3a"
const script = {}

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__